/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-indent */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  Container, Row, Col, Button,
} from 'reactstrap';
import moment from 'moment';
import _ from 'lodash';
import ReactTooltip from 'react-tooltip';

import {
  AsyncTableInfinite,
  Intl,
  TableSelectFilter,
  Checkbox,
  AudioModal,
  ConfirmationModal,
} from 'components';
import { formatPhone } from 'utils';

const RenderAudios = React.memo(({ call, toggleAudioModal }) => {
  const action = _.get(call, 'action');
  const logs = _.get(call, 'logs');
  const listened = logs?.listened && logs?.listened !== '' && logs?.listened !== '0' ? logs?.listened : '';
  const digits_pressed = logs?.digits_pressed && logs?.digits_pressed !== ''
    ? logs?.digits_pressed
    : '';
  const farewell_listened = logs?.farewell_listened && logs?.farewell_listened !== '' && logs?.farewell_listened !== '0'
    ? logs?.farewell_listened
    : '';
  const intro_listened = logs?.intro_listened && logs?.intro_listened !== '' && logs?.intro_listened !== '0'
    ? logs?.intro_listened
    : '';
  const option_listened = logs?.option_listened && logs?.option_listened !== '' && logs?.option_listened !== '0'
    ? logs?.option_listened
    : '';
  let subMessage = '';
  // if ( logs.digits_pressed ) {
  if (digits_pressed !== '' && digits_pressed !== 'null') {
    subMessage = <Intl id="pressedValue" values={{ pressedValue: digits_pressed }} />;
  }
  else if (call.action === 'None') {
    subMessage = ''
  }
  else if (logs?.listened) {
    if (listened === '1') {
      subMessage = <Intl id="listened" />;
    } else if (listened === '0' || listened === '') {
      subMessage = <Intl id="hungUp" />;
    }
  }
  else if (
    intro_listened === '1'
    // && option_listened === '1'
    && farewell_listened === '1'
  ) {
    subMessage = <Intl id="listenedIOF" />;
  } else if (
    intro_listened === '1'
    && option_listened === '1'
    && farewell_listened === ''
  ) {
    subMessage = <Intl id="listenedIO" />;
  } else if (
    intro_listened === '1'
    && option_listened === ''
    && farewell_listened === ''
  ) {
    subMessage = <Intl id="listenedI" />;
  }
  else if (
    digits_pressed === ''
    && farewell_listened === ''
    && intro_listened === ''
    && option_listened === ''
  ) {
    subMessage = <Intl id="hungUp" />;
  } else {
    subMessage = <Intl id="hungUp" />;
  }

  // }

  const uid = Date.now().toString(36) + Math.random().toString(36).substr(2);
  if (!_.get(call, 'configData.audios')) {
    return null;
  }

  if (call.action === 'None') {
    return (
      <></>
    )
  }

  if (call.action === 'simple_message') {
    return (
      <>
        <div
          data-tip="simple_message"
          style={{ width: '100%', textAlign: 'left', paddingLeft: '15px' }}
          data-for={`action_${uid}_1`}
        >
          <Button
            color="outline-link"
            className="p-0"
            style={{ textAlign: 'left', width: '100%' }}
            data-tip={
              call.configData.audios.message_audio
                && call.configData.audios.message_audio.name
                ? call.configData.audios.message_audio.name
                : 'Audio1'
            }
            data-for={`action_${uid}_1`}
            onClick={() => call.configData.audios.message_audio && call.configData.audios.message_audio.name ? toggleAudioModal('audioVoiceName', _.get(call.configData.audios, 'message_audio.uri'), call.configData.audios.message_audio.name.replace(".mp3", "")) : toggleAudioModal('introduction', _.get(call.configData.audios, 'message_audio.uri'))}
          >
            {call.configData.audios.message_audio
              && call.configData.audios.message_audio.name
              ? call.configData.audios.message_audio.name
              : 'Audio1'}
          </Button>
        </div>
        <div style={{ width: '100%', textAlign: 'left', paddingLeft: '15px' }}>
          {subMessage}
        </div>
        <ReactTooltip
          id={`action_${uid}_1`}
          place="bottom"
          aria-haspopup="true"
          getContent={(dataTip) => (dataTip === 'simple_message' ? (
            <Intl id="simple_message" />
          ) : (
            `${dataTip?.replace(".mp3", "")}`
          ))}
        />
      </>
    );
  }
  // if ( call.configData.audios.intro_audio && call.configData.audios.question_audio
  //   && call.configData.audios.closing_audio ) {
  return (
    <>
      <div
        style={{ width: '100%', textAlign: 'left', paddingLeft: '15px' }}
        data-tip="survey"
        data-for={`action_${uid}_1`}
      >
        <Button
          color="outline-link"
          className="p-0 m-0"
          style={{ textAlign: 'left', width: '128px' }}
          data-tip={
            call.configData.audios.intro_audio
              && call.configData.audios.intro_audio.name
              ? call.configData.audios.intro_audio.name
              : 'introduction'
          }
          data-for={`action_${uid}_1`}
          // onClick={() => toggleAudioModal(
          //   'introduction',
          //   _.get(call.configData.audios, 'intro_audio.uri'),
          // )}
          onClick={() => call.configData.audios.intro_audio && call.configData.audios.intro_audio.name ? toggleAudioModal('audioVoiceName', _.get(call.configData.audios, 'intro_audio.uri'), call.configData.audios.intro_audio.name.replace(".mp3", "")) : toggleAudioModal('introduction', _.get(call.configData.audios, 'intro_audio.uri'))}
        >
          {call.configData.audios.intro_audio
            && call.configData.audios.intro_audio.name ? (
            call.configData.audios.intro_audio.name
          ) : (
            <Intl id="introduction" />
          )}
        </Button>
        <span> |&nbsp;</span>
        <Button
          color="outline-link"
          className="p-0 m-0"
          style={{ width: '128px' }}
          data-tip={
            call.configData.audios.question_audio
              && call.configData.audios.question_audio.name
              ? call.configData.audios.question_audio.name
              : 'options'
          }
          data-for={`action_${uid}_1`}
          // onClick={() => toggleAudioModal(
          //   'options',
          //   _.get(call.configData.audios, 'question_audio.uri'),
          // )}
          onClick={() => call.configData.audios.question_audio && call.configData.audios.question_audio.name ? toggleAudioModal('audioVoiceName', _.get(call.configData.audios, 'question_audio.uri'), call.configData.audios.question_audio.name.replace(".mp3", "")) : toggleAudioModal('introduction', _.get(call.configData.audios, 'question_audio.uri'))}
        >
          {call.configData.audios.question_audio
            && call.configData.audios.question_audio.name ? (
            call.configData.audios.question_audio.name
          ) : (
            <Intl id="options" />
          )}
        </Button>
        <span> |&nbsp;</span>
        <Button
          color="outline-link"
          className="p-0 m-0"
          style={{ width: '128px' }}
          data-tip={
            call.configData.audios.closing_audio
              && call.configData.audios.closing_audio.name
              ? call.configData.audios.closing_audio.name
              : 'farewell'
          }
          data-for={`action_${uid}_1`}
          // onClick={() => toggleAudioModal(
          //   'farewell',
          //   _.get(call.configData.audios, 'closing_audio.uri'),
          // )}
          onClick={() => call.configData.audios.closing_audio && call.configData.audios.closing_audio.name ? toggleAudioModal('audioVoiceName', _.get(call.configData.audios, 'closing_audio.uri'), call.configData.audios.closing_audio.name.replace(".mp3", "")) : toggleAudioModal('introduction', _.get(call.configData.audios, 'closing_audio.uri'))}
        >
          {call.configData.audios.closing_audio
            && call.configData.audios.closing_audio.name ? (
            call.configData.audios.closing_audio.name
          ) : (
            <Intl id="farewell" />
          )}
        </Button>
      </div>
      <div style={{ width: '100%', textAlign: 'left', paddingLeft: '15px' }}>
        {subMessage}
      </div>
      <ReactTooltip
        id={`action_${uid}_1`}
        place="bottom"
        aria-haspopup="true"
        getContent={(dataTip) => (dataTip === 'survey' ? (
          <Intl id="survey" />
        ) : dataTip === 'introduction' ? (
          <Intl id="introduction" />
        ) : dataTip === 'options' ? (
          <Intl id="options" />
        ) : dataTip === 'farewell' ? (
          <Intl id="farewell" />
        ) : (
          `${dataTip}`
        ))}
      />
    </>
  );
  // }
  // return null;
});

export default ({
  data,
  isLoading,
  phoneNumbers,
  phoneNumbersLoading,
  selectedRows,
  onFetchData,
  onToggleRowChecked,
  onToggleAllRowsChecked,
  onExport,
  onDelete,
}) => {
  const [audioModal, setAudioModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [pageLen, setPageLen] = useState(0);
  const audioRef = useRef({});

  const toggleAudioModal = useCallback((type, audio, values) => {
    audioRef.current = { type, audio, values };
    setAudioModal((state) => !state);
  }, []);

  const toggleDeleteModal = useCallback(() => {
    setDeleteModal((state) => !state);
  }, []);

  const changePageLength = useCallback((val) => setPageLen(val), []);

  const secToMin = (value) => {
    var timestamp = value;
    var hours = Math.floor(timestamp / 60 / 60);
    var minutes = Math.floor(timestamp / 60) - hours * 60;
    var seconds = timestamp % 60;
    // hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
    var formatted =
      minutes.toString().padStart(2, "0") +
      ":" +
      seconds.toString().padStart(2, "0");
    return formatted;
  };

  return (
    <Container fluid className="mt-3 search-box">
      <AsyncTableInfinite
        data={data.data}
        total={data.total}
        isLoading={isLoading}
        onFetchData={onFetchData}
        defaultSortBy={[{ id: 'createdAt', desc: true }]}
        tableClassName="m-0"
        customFilters={({ filters, setFilter }) => (
          <>
            <Row className="align-items-center">
              <Col md={3} className="pt-1 pt-lg-0">
                {/* {filters && filters.phoneNumber ? ( */}
                {!isLoading && filters && filters.accountDirectDial ? (
                  <Intl id="totalCallPerPhone" values={{ total: data.total }} />
                ) : (
                  ''
                )}
              </Col>
              <Col md={9} className="pt-1 pt-lg-0">
                <TableSelectFilter
                  name="accountDirectDial"
                  placeholder="selectAnswerNumber"
                  filters={filters}
                  setFilter={setFilter}
                  options={phoneNumbers}
                  isLoading={phoneNumbersLoading}
                />
              </Col>
            </Row>
          </>
        )}
        columns={[
          {
            Header: (
              <Checkbox
                name="header"
                divStyle={{ width: 'auto' }}
                formGroupClass="m-0 table-checkbox"
                value={
                  data.data
                  && data.data.length
                  && !_.difference(_.map(data.data, 'id'), selectedRows).length
                }
                onChange={onToggleAllRowsChecked}
              />
            ),
            disableSorting: true,
            disableTranslate: true,
            id: 'check',
            accessor: 'id',
            // maxWidth: 10,
            width: 8,
            style: { padding: 0, height: '50px' },
            Cell: ({ cell }) => (
              <Checkbox
                name={cell.value}
                formGroupClass="m-0 table-checkbox"
                value={selectedRows.indexOf(cell.value) !== -1}
                onChange={(value) => onToggleRowChecked(cell.value, value)}
              />
            ),
          },
          {
            Header: 'dateTime',
            accessor: 'createdAt',
            Cell: ({ cell }) => (cell.value
              ? moment(Number(cell.value)).format('YYYY-MM-DD HH:mm:ss')
              : ''),
            width: 16.5,
          },
          {
            Header: 'caller',
            accessor: 'callerNumber',
            Cell: ({ cell }) => (cell.value ? formatPhone(cell.value) : ''),
            width: 16.5,
          },
          {
            Header: 'message',
            accessor: 'configData',
            style: { display: 'block' },
            disableSorting: true,
            Cell: ({ cell }) => (
              <RenderAudios
                call={cell.row.original}
                toggleAudioModal={toggleAudioModal}
              />
            ),
            width: 40,
          },
          {
            Header: 'voicemail',
            accessor: 'audioVoicemail',
            disableSorting: true,
            style: { display: 'block' },
            Cell: ({ cell }) => {
              const uid = Date.now().toString(36) + Math.random().toString(36).substr(2);
              const [time, setTime] = useState('');
              if (cell.value && cell.value !== 'url') {
                var au = document.createElement('audio');
                au.src = cell.value;
                au.addEventListener('loadedmetadata', function () {
                  var duration = au.duration;
                  setTime(secToMin(Math.round(duration)));
                }, false);
              }

              //  cell.value && cell.value !== 'url' ? 
              return (
                <>
                  <div>
                    {
                      cell.row.original.configData && cell.row.original.configData.audios && cell.row.original.configData.audios.voicemail_audio && cell.row.original.configData.audios.voicemail_audio.uri ? <Button
                        color="outline-link"
                        className="p-0"
                        data-tip
                        data-for={`voicemail_${uid}_1`}
                        onClick={() => toggleAudioModal('audioVoiceName', cell.row.original.configData.audios.voicemail_audio.uri, cell.row.original.configData.audios.voicemail_audio.name.replace(".mp3", ""))}
                      >
                        <Intl id="audioVoiceName" values={{ name: cell.row.original.configData.audios.voicemail_audio.name }} />
                      </Button>
                        : <></>
                    } <br />
                    {
                      cell.value && cell.value !== 'url' ? <Button
                        color="outline-link"
                        className="p-0"
                        data-tip
                        data-for={`voicemail_${uid}_1`}
                        onClick={() => toggleAudioModal('recordedMessage', cell.value, cell.row.original.createdAt
                          ? moment(Number(cell.row.original.createdAt)).format('YYYY-MM-DD HH:mm')
                          : '')}
                      >
                        {time === 'NaN:NaN' ? '-' : time}
                      </Button> : <></>
                    }
                    <ReactTooltip
                      id={`voicemail_${uid}_1`}
                      place="bottom"
                      aria-haspopup="true"
                    >
                      {/* { cell.row.original.configData && cell.row.original.configData.audios && cell.row.original.configData.audios.voicemail_audio && <Intl id="audioVoiceName" values={{ name: cell.row.original.configData.audios.voicemail_audio.name.replace(".mp3", "") }} />} */}
                      { cell.row.original.configData && cell.row.original.configData.audios && cell.row.original.configData.audios.voicemail_audio && <Intl id="audioVoiceName" />}
                    </ReactTooltip>
                  </div>
                  {/* <div>
                    {time}
                  </div> */}
                </>
              )
              // : (
              //   <>

              //   </>
              // );
            },
            width: 20,
          },
        ]}
        minHeight
        headerWidth={['col-0-3qtr nopadding', 'col-2', 'col-2', 'col-5', 'col']}
        minRows={14}
        changePageLength={changePageLength}
      />
      <Row>
        <Col>
          <span className="text-gray-3 text-sm">
            <Intl id="recordsDeleteRange" />
          </span>
        </Col>
        <Col className="text-right">
          <Button color="outline-link" className="p-0" onClick={onExport}>
            <Intl id="download" />
          </Button>
          <Button
            color="outline-link"
            className="p-0"
            onClick={toggleDeleteModal}
          >
            <Intl id="delete" />
          </Button>
        </Col>
      </Row>

      {audioModal && (
        <AudioModal
          uri={audioRef.current.audio}
          modalTitle={audioRef.current.type}
          values={audioRef.current.values}
          open={audioModal}
          translateTitle
          download
          onClose={toggleAudioModal}
        />
      )}

      {deleteModal && (
        <ConfirmationModal
          open={deleteModal}
          title="deleteModalCalls.confirmation"
          onConfirm={() => onDelete(toggleDeleteModal)}
          onClose={toggleDeleteModal}
        />
      )}
    </Container>
  );
};
